"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var _a;
/**
 * @hidden
 */
exports.labelsOptional = 'labels.optional';
/**
 * @hidden
 */
exports.messages = (_a = {},
    _a[exports.labelsOptional] = '(Optional)',
    _a);
//# sourceMappingURL=index.js.map